/**
 * Notification Service - Evaluates if any notification needs to be displayed to the user
 *
 **/
define('notifications/notification-services',['require','exports','module','lodash','lib/models/account/is-marvel-account','moment','cookie-handler','lib/models/account/find-expiring-trial','lib/models/account/check-meetings-after-date'],function (require, exports, module) {
    var _ = require('lodash');
    var isMarvelAccount = require('lib/models/account/is-marvel-account');
    var moment = require('moment');
    var cookieHandler = require('cookie-handler');
    var findExpiringTrial = require('lib/models/account/find-expiring-trial');
    var checkMeetingsAfterDate = require('lib/models/account/check-meetings-after-date');

    var findPendingNotification = {
        'trial-ending-marvel-notification': function (config) {
            if (config.isMarvel && !config.isTrialExpired) {
                if ((config.trialDaysLeft === 3 || config.trialDaysLeft === 2) && !config.marvelTrial3DayLeftViewed) {
                    return true;
                } else if (config.trialDaysLeft <= 1 && !config.marvelTrial1DayLeftViewed) {
                    return true;
                }
            }
            return undefined;
        },
        'trial-end-notification': function (config) {
            return config.isMarvel && config.isTrialExpired && config.hasVoipOnly && !config.marvelTrialExpiredViewed;
        },
        'downgrade-notification': function (config) {
            return config.isMarvel && config.hasVoipOnly && config.onboardingViewed &&
                !config.downgradeNotificationViewed;
        },
        'trial-ending-non-marvel-notification': function (config) {
            return !config.isMarvel && !config.isTrialExpired && config.expiringTrial && config.isBillingAdmin &&
                config.postTrialMeetingType === 'NONE' && !config.nonMarvelTrialModalShown && config.trialDaysLeft <= 1;
        }
    };

    var getPendingNotifications = function (configResponse) {
        var config = configResponse || {};
        var result;
        var keys = Object.keys(findPendingNotification);
        var notifLength = keys.length;
        for (var i = 0; i < notifLength; i++) {
            result = findPendingNotification[keys[i]](config);
            if (result) {
                return keys[i];
            }
        }
        return '';
    };

    // translate API responses into a configuration object
    // that has meaning to the notifications
    var formatConfigFromApi = function (settingsResponse, productsResponse, tierSettingsResponse, userMeResponse) {
        var settings = settingsResponse[0];
        var products = productsResponse[0];
        var tierSettings = (tierSettingsResponse || [])[0];
        var userMe = userMeResponse[0];

        var g2mProduct = _.findWhere(products, {
            product: 'GoToMeeting'
        });
        var isG2mTrial = !!g2mProduct && g2mProduct.trial === true;
        var isG2mTrialExpired = !!g2mProduct && g2mProduct.trial === true && g2mProduct.active === false;
        var hasVoipOnly = settings.nativeEndpointDisabled;
        var onboardingViewed = !!(tierSettings || {}).onboardingViewed;
        var downgradeNotificationViewed = !!(settings || []).downgradeNotificationViewed;
        var isMarvel = isMarvelAccount(products);
        var nonMarvelTrialModalShown = cookieHandler.get('trial-modal-shown');
        var expiringTrial = findExpiringTrial(products, moment().endOf('day').add(3, 'd'));
        var isBillingAdmin = expiringTrial && userMe.key === expiringTrial.billingAdminUserKey;
        var endDate = expiringTrial && moment(expiringTrial.endDate);
        var seats = expiringTrial && expiringTrial.seats;
        var postTrialMeetingType = expiringTrial && checkMeetingsAfterDate(endDate, isBillingAdmin, seats);
        var marvelTrial3DayLeftViewed = !!(settings || []).marvelTrial3DayLeftViewed;
        var marvelTrial1DayLeftViewed = !!(settings || []).marvelTrial1DayLeftViewed;
        var marvelTrialExpiredViewed = !!(settings || []).marvelTrialExpiredViewed;
        var trialDaysLeft = expiringTrial && moment(expiringTrial.endDate).diff(moment(), 'days');

        return {
            hasVoipOnly: hasVoipOnly,
            isTrial: isG2mTrial,
            isTrialExpired: isG2mTrialExpired,
            onboardingViewed: onboardingViewed,
            downgradeNotificationViewed: downgradeNotificationViewed,
            isMarvel: isMarvel,
            nonMarvelTrialModalShown: nonMarvelTrialModalShown,
            expiringTrial: expiringTrial,
            isBillingAdmin: isBillingAdmin,
            postTrialMeetingType: postTrialMeetingType,
            marvelTrial3DayLeftViewed: marvelTrial3DayLeftViewed,
            marvelTrial1DayLeftViewed: marvelTrial1DayLeftViewed,
            marvelTrialExpiredViewed: marvelTrialExpiredViewed,
            trialDaysLeft: trialDaysLeft
        };
    };

    module.exports = {
        /**
         * getPendingNotifications
         * @param {object} config - configuration settings in the following shape:
         * @param {object} config.isTrialExpired -
         * @param {object} config.hasVoipOnly -
         *
         * @return {Array} A list of notification components that need to be displayed to the user
         */
        getPendingNotifications: getPendingNotifications,

        /**
         * formatConfigFromApi
         *
         * Translate API responses into a configuration object
         * that has meaning to the notifications.
         * Interprets combinations of flags and objects from the API to figure out
         * the state of the current account/user that will be used to figure out
         * what notification to show
         *
         * @param {object} settings - Response from meetingSrv.settings() call  - meetingSrv/rest/v2/settings
         * @param {object} products - Response from extAdminApi.products() call  commerce/account/<acc>/products
         * @param {object} g2mTierSettings - Response from call  meetingSrv/rest/v2/settings?tier=g2m
         *
         * @return {object} - A configuration object with relevant flags for notifications
         *
         **/
        formatConfigFromApi: formatConfigFromApi
    };
});

